import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmmodalComponent } from './confirmmodal/confirmmodal.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationModalComponent } from './confirm-modal/confirm-modal.component';
import { ModaldialogComponent } from './modaldialog/modaldialog.component';
import { NotificationComponent } from './notification/notification.component';
import { ProgressComponent } from './progress/progress.component';
import { TrimOnBlurDirective } from 'src/app/directives/trimOnBlur.directive';
import { NumericDirective } from 'src/app/directives/positive-decimals.directive';
import { IntegerDirective } from 'src/app/directives/positive-integers.directive';
import { SpecialCharDirective } from 'src/app/directives/remove-special.directive';
import { ResizableDirective } from './resizable-table/resiazble-table.directive';
import { ResizableComponent } from './resizable-table/resizable-table.component';
import { SuccessmodalComponent } from './successmodal/successmodal.component';
import { SuccessConfirmmodalComponent } from './successconfirmmodal/successconfirmmodal.component';
import { FailureModalComponent } from './failure-modal/failure-modal.component';
import { PagingComponent } from './paging/paging.component';
import { UploadComponent } from './upload/upload.component';
import { AddressValidationComponent } from './address-validation/address-validation.component';
import { AppMaterialModule } from 'src/app/shared/appmaterial/appmaterial.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GlobalelementConfirmPopupComponent } from './globalelement-confirm-popup/globalelement-confirm-popup.component';
import { LocksListComponent } from './locks-list-component/locks-list/locks-list.component'; // used in workflow common submit and discard popup
import { PrintRequestorComponent } from './printrequestor/print-requestor.component';
import { MultiCheckFieldComponent } from './multicheckfield/multi-check-field.component';
import { SimpleCheckOptionComponent } from './multicheckfield/simple-check-option/simple-check-option.component';
import { ASNGridPopupComponent } from './asngrid-popup/asngrid-popup.component';
import { ASNNumberPopupComponent } from './asnnumber-popup/asnnumber-popup.component';
import { InfomodalComponent } from './infomodal/infomodal.component';
import { SortByPipe } from 'src/app/pipes/sort-by.pipe';

@NgModule({
  declarations: [
    ProgressComponent,
    ModaldialogComponent,
    NotificationComponent,
    ConfirmmodalComponent,
    ConfirmationDialogComponent,
    ConfirmationModalComponent,
    GlobalelementConfirmPopupComponent,
    SuccessmodalComponent,
    SuccessConfirmmodalComponent,
    ResizableComponent,
    ResizableDirective,
    TrimOnBlurDirective,
    NumericDirective,
    IntegerDirective,
    SpecialCharDirective,
    FailureModalComponent,
    PagingComponent,
    UploadComponent,
    AddressValidationComponent,
    LocksListComponent,
    PrintRequestorComponent,
	  SimpleCheckOptionComponent,
	  MultiCheckFieldComponent,
    ASNGridPopupComponent,
    ASNNumberPopupComponent,
    InfomodalComponent,
    SortByPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
  ],
  exports: [
    FailureModalComponent,
    ProgressComponent,
    ModaldialogComponent,
    NotificationComponent,
    ConfirmmodalComponent,
    ConfirmationDialogComponent,
    ConfirmationModalComponent,
    SuccessmodalComponent,
    SuccessConfirmmodalComponent,
    ResizableComponent,
    UploadComponent,
    AddressValidationComponent,
    TrimOnBlurDirective,
    NumericDirective,
    PrintRequestorComponent,
    IntegerDirective,
    SpecialCharDirective,
	  SimpleCheckOptionComponent,
	  MultiCheckFieldComponent,
    ASNGridPopupComponent,
    ASNNumberPopupComponent,
    InfomodalComponent,
    SortByPipe
  ],
  providers: [
    SortByPipe
  ]
})
export class FscCommonModule { }
